// Admin application entry point - bundled with esbuild
import "@hotwired/turbo-rails";
import "./controllers";
import "./channels";

import Turn from "@domchristie/turn";
Turn.start();

// Set user timezone cookie
document.addEventListener("DOMContentLoaded", function () {
  if (Intl.DateTimeFormat().resolvedOptions().timeZone) {
    document.cookie =
      "user_time_zone=" +
      Intl.DateTimeFormat().resolvedOptions().timeZone +
      "; path=/; SameSite=Lax; Secure=true";
  }
});
